import { Star } from "lucide-react";

export const RelevanceScore = ({ value = 0, size = 14 }) => (
  <span className="inline-flex items-center gap-0.5" data-testid="relevance-score" title={`Relevance ${value}/5`}>
    {[1, 2, 3, 4, 5].map((n) => (
      <Star key={n} size={size} strokeWidth={1.5} className={n <= value ? "fill-[#C9A227] text-[#C9A227]" : "text-[#CBD5EA]"} />
    ))}
  </span>
);
